import CryptoJS from "crypto-js";
import {AGENT_CLINIC, AWAITING_REVIEW} from '../constants';
import moment from "moment";
let UTILS = {
  generateMD5HashFromString:(strValue)=>{
    return CryptoJS.MD5(strValue).toString(CryptoJS.enc.Hex);
  },
  storeStringDataTolocalStorage: async (keyName, value) => {
    try {
      console.log(`localStorage save as key ${keyName} - `, value);
      await localStorage.setItem(keyName, value)
    } catch (e) {
      console.log('store to localStorage error', e);
    }
  },
  readStringDataFromlocalStorage: async (keyName) => {
    try {
      return await localStorage.getItem(keyName);
    } catch (e) {
      console.log(`read key ${keyName} from localStorage error`, e);
    }
  },
  readStringDataFromlocalStorageAndDecrypt: async (keyName) => {
    try {
      let data = await localStorage.getItem(keyName);
      if (data && data.indexOf(':') != -1) {
        // console.log(`Need decription key ${keyName} - `, data);
        data = await UTILS.decryptStringAES(data);
      }
      return data
    } catch (e) {
      console.log(`read key ${keyName} from localStorage error`, e);
    }
  },
  storeObjectDataTolocalStorage: async (keyName, value) => {
    try {
      console.log(`localStorage save as key ${keyName}`);
      const jsonValue = JSON.stringify(value)
      let aesdata = await UTILS.encryptStringAES(jsonValue)
      await localStorage.setItem(keyName, aesdata)
    } catch (e) {
      console.log('store to localStorage error', e);
    }
  },
  readObjectDataFromlocalStorage: async (keyName) => {
    try {
      const aesdata = await localStorage.getItem(keyName)
      if (aesdata) {
        let data = await UTILS.decryptStringAES(aesdata)
        console.log('readObjectDataFromlocalStorage by keyname: ', keyName)
        return data !== null ? JSON.parse(data) : null;
      }
      return null;
    } catch (e) {
      console.log(`read key ${keyName} from localStorage error`, e);
    }
  },
  removeDataFromlocalStorage: async (keyName) => {
    try {
      await localStorage.removeItem(keyName)
    } catch (e) {
      console.log('removeDataFromlocalStorage error', e);
    }
  },

  clearDataFromlocalStorage: async () => {
    try {
      await localStorage.clear()
    } catch (e) {
      console.log('clearDataFromlocalStorage error', e);
    }
    console.log('Done.')
  },
  createHashStringSHA1: async (strValue) => {
    try {
      return CryptoJS.SHA1(strValue)
    } catch (e) {
      console.log('createHashStringSHA1: error', e);
    }
  },
  encryptStringAES: async (str) => {
    // Encrypt
    const IV_LENGTH = 16; // For AES, this is always 16
    let iv = CryptoJS.lib.WordArray.random(IV_LENGTH);
    let secret = await UTILS.getAESSecret();
    let encrypted = CryptoJS.AES.encrypt(str, secret, { iv: iv, keySize: 256 / 32 });
    let iv_str = encrypted.iv.toString();
    return `${iv_str}:${encrypted.toString()}`
  },

  decryptStringAES: async (data) => {
    let secret = await UTILS.getAESSecret();
    let textParts = data.split(':');
    let iv = textParts.shift();
    let chiperText = textParts[0];
    var bytes = CryptoJS.AES.decrypt(chiperText, secret, { iv, keySize: 256 / 32 });
    var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  },
  base64_to_base10: (str) => {
    var order = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
    var base = order.length;
    var num = 0, r;
    while (str.length) {
      r = order.indexOf(str.charAt(0));
      str = str.substr(1);
      num *= base;
      num += r;
    }
    return num;
  },

  base10_to_base64: (num) => {
    var order = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
    var base = order.length;
    var str = "", r;
    while (num) {
      r = num % base
      num -= r;
      num /= base;
      str = order.charAt(r) + str;
    }
    return str;
  },
  generateAESSecret: async () => {
    let str = "Connecting to your favorite app has never been that easy.";
    str = str + str;
    const hash = CryptoJS.SHA1(str);
    let hashStr = hash.toString(CryptoJS.enc.Hex);
    hashStr = hashStr.substring(0, 16);
    console.log("hashStr - ", hashStr);
    return hashStr;
  },
  getAESSecret: async () => {
    return await UTILS.generateAESSecret();
  },
  removeItemFromArrayUsingIndex:(array,index)=> {
    let responseBuffer = [];
    array.map((item, indexValue) => {
      if (indexValue !== index) {
        responseBuffer.push(item);
      }
    })
    return responseBuffer;
  },
  removeDuplicates:(data)=>{
    return data.filter((value,index)=>data.indexOf(value)===index);
  },
  /**
   * Restricts text field ONLY to a float type input.
   */
  formatInput:(e) => {
    // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
    let checkIfNum;
    if (e.key !== undefined) {
      checkIfNum = e.key === "e" || e.key === "+" || e.key === "-" ;
    }
    else if (e.keyCode !== undefined) {
      // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
      checkIfNum = e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 187 || e.keyCode === 189;
    }
    return checkIfNum && e.preventDefault();
  },
  numberWithCommas:(x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  /**
   * Converts state from CreateCase page to POST Object
   * @returns hashValue
   */
  convertCreateCaseStateToPOSTObject:(state,userid,entityid,effectivedate,agencycode,agencyname)=>{
    //Generate POST Object()

    let postObject = {};
    let hashValue = UTILS.generateMD5HashFromString( state.membername +"#"+ state.familyname +"#"+ state.policyno +"#"+ new Date().toLocaleString());
    //postObject.insuredname =  state.membername + " " +  state.familyname;
    postObject.insuredname = state.insuredname;
    postObject.nicnumber =  state.nicnumber;
    postObject.policyno =  state.policyno;
    postObject.admissionid =  state.admissionid;
    postObject.dateofdischarge =  state.dateofdischarge;
    postObject.entityid = entityid;
    postObject.effectivedate = effectivedate;
    postObject.billvalue =  state.billvalue;
    postObject.dateofbirth = new moment(state.dateofbirth).toDate();
    postObject.expirydate = new moment(state.expirydate).toDate();
    postObject.ecpolicyid =  state.policyno;
    postObject.caseid = hashValue;
    postObject.additionaldetails = state.additionaldetails;
    postObject.active = "YES";
    postObject.commonid = state.commonid;
    postObject.dateofadmission = new moment(state.dateofadmission).toDate();
    postObject.treatmenttype = state.selectedTreatmentType;
    postObject.diagnosis = state.selectedDiagnosis;
    postObject.otherdiagnosis = state.selectedOtherDiagnosis;
    postObject.admittingdoctor =  state.selectedDoctor;
    postObject.billtype = state.selectedBillType;
    postObject.procedure1 = state.selectedProcedureOne;
    postObject.procedure2 = state.selectedProcedureTwo;
    postObject.procedure3 =  state.selectedProcedureThree;
    postObject.valuecovered = "";
    postObject.userid = userid;
    postObject.timestamp = new moment().toDate();
    postObject.dtsubmit = new moment().toDate();
    //Enforce empty so that swan comments table stays empty.
    postObject.dtreview = "";
    postObject.approvalstatus = AWAITING_REVIEW;
    postObject.swancomments = "";
    postObject.agencycode = agencycode;
    postObject.reviewedby = "";
    postObject.agencyname = agencyname;
    postObject.status = "IDLE";
    postObject.swanuser = "";
    postObject.reviewstartedat = "";
    postObject.reviewendedat = "";
    postObject.hashValue = hashValue;
    postObject.claimno1 = "";
    postObject.claimno2 = "";
    return postObject;
  },
  /**
   *
   * @param dateVal
   * @returns Formatted date in DD/MM/YYYY HH:MM AM_PM
   */
  getTimeStamp:()=>{
    var newDate = new Date();

    var sMonth = padValue(newDate.getMonth() + 1);
    var sDay = padValue(newDate.getDate());
    var sYear = newDate.getFullYear();
    var sHour = newDate.getHours();
    var sMinute = padValue(newDate.getMinutes());
    var sAMPM = "AM";

    var iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
      sAMPM = "PM";
      sHour = iHourCheck - 12;
    }
    else if (iHourCheck === 0) {
      sHour = "12";
    }
    sHour = padValue(sHour);
    return sDay + "/" + sMonth + "/" + sYear + " " + sHour + ":" + sMinute + " " + sAMPM;
  },
  /**
   *
   * @param dateVal
   * @returns Formatted date in DD/MM/YYYY HH:MM AM_PM
   */
  formatDate:(dateVal)=>{
    var newDate = new Date(dateVal);

    var sMonth = padValue(newDate.getMonth() + 1);
    var sDay = padValue(newDate.getDate());
    var sYear = newDate.getFullYear();
    var sHour = newDate.getHours();
    var sMinute = padValue(newDate.getMinutes());
    var sAMPM = "AM";

    var iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
      sAMPM = "PM";
      sHour = iHourCheck - 12;
    }
    else if (iHourCheck === 0) {
      sHour = "12";
    }
    sHour = padValue(sHour);
    return sDay + "/" + sMonth + "/" + sYear + " " + sHour + ":" + sMinute + " " + sAMPM;
  },
  /**
   *
   * @param dateVal
   * @returns Formatted date in DD/MM/YYYY ONLY
   */
  getDateAsDDMMYYYY:(dateVal)=> {
    var newDate = new Date(dateVal);
    var sMonth = padValue(newDate.getMonth() + 1);
    var sDay = padValue(newDate.getDate());
    var sYear = newDate.getFullYear();
    return sDay + "/" + sMonth + "/" + sYear;
  },
  /**
   * Detects where user is a swan staff
   * @param props
   * @returns boolean
   */
  isSwanUser:(props)=>{
    var selector = true;
    if(props.auth.data){
      if(props.auth.data.usertype == AGENT_CLINIC){selector = false}
    }
    return selector;
  }

}

const padValue = (value) =>{
  return (value < 10) ? "0" + value : value;
}

export default UTILS;

